import { gql } from "@apollo/client"

export const CREATE_ACT_ADMIN = gql`
  mutation createACTAdmin($data: CreateACTAdminRequest!) {
    actAdmin {
      create(data: $data)
    }
  }
`

export const UPDATE_ACT_ADMIN = gql`
  mutation updateACTAdmin($data: UpdateACTAdminRequest!) {
    actAdmin {
      update(data: $data)
    }
  }
`
